import { useEffect, useState } from "react";
import { useFieldContext } from "@/features/question/components/organisms/FieldRenderer";
import { Checkbox } from "@/components/ui/checkbox";


export function BooleanRenderer() {
    const { question, setFormValue, disabled, response, currentValue } = useFieldContext();
    const [value, setValue] = useState<boolean>(false);

    const field_min_label = question?.field_min_label;
    const field_max_label = question?.field_max_label;

    useEffect(() => {
        if(currentValue) {
            let _currentValue = currentValue;
            if(typeof currentValue === 'string') {
                _currentValue = currentValue === "true" ? true : false;
            }
            setValue( _currentValue );
        }
    }, [currentValue]);

    useEffect(() => {
        if (setFormValue) {
            setFormValue(value !== undefined ? value.toString() : null);
        }
    }, [value, setFormValue]);

    useEffect(() => {
        if (response?.field_value) {
            setValue(response.field_value === 'true');
        } 
        // else {
        //     setValue(false);
        // }
    }, [response]);

    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center space-x-2">
                <Checkbox
                    id="boolean-option-true"
                    checked={value === true}
                    onCheckedChange={(checked) => {
                        if (checked !== 'indeterminate')
                            setValue(true);
                    }}
                    disabled={disabled}
                    className="w-5 h-5 form-checkbox text-primary"
                />
                <label htmlFor={"boolean-option-true"} className="text-sm">{field_max_label}</label>
            </div>

            <div className="flex items-center space-x-2">
                <Checkbox
                    id="boolean-option-false"
                    checked={value === false}
                    onCheckedChange={(checked) => {
                        if (checked !== 'indeterminate')
                            setValue(false);
                    }}
                    disabled={disabled}
                    className="w-5 h-5 form-checkbox text-primary"
                />
                <label htmlFor={"boolean-option-false"} className="text-sm">{field_min_label}</label>
            </div>
        </div>
    )
}
